// src/utils/cryptoUtils.js
import CryptoJS from "crypto-js";

const SECRET_KEY = "your-strong-secret-key"; // use same key everywhere

// Encrypt any string or number
export const encryptData = (plainText) => {
  if (plainText === undefined || plainText === null) return "";
  try {
    return CryptoJS.AES.encrypt(plainText.toString(), SECRET_KEY).toString();
  } catch (err) {
    console.error("Encryption error:", err);
    return "";
  }
};

// Decrypt any string
export const decryptData = (cipherText) => {
  if (!cipherText) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8) || null;
  } catch (err) {
    console.error("Decryption error:", err);
    return null;
  }
};

// Save multiple user info fields to sessionStorage
export const saveUserSession = (data) => {
  try {
    sessionStorage.setItem("token", encryptData(data.access));
    sessionStorage.setItem("role", encryptData(data.user.role_type));
    sessionStorage.setItem("email", encryptData(data.user.email));
    sessionStorage.setItem("gender", encryptData(data.user.gender));
    sessionStorage.setItem("name", encryptData(data.user.name));
    sessionStorage.setItem("userId", encryptData(data.user.id));
  } catch (err) {
    console.error("Error saving user session:", err);
  }
};

// Get token from sessionStorage and decrypt
export const getToken = () => {
  const encryptedToken = sessionStorage.getItem("token");
  console.log('token:', encryptedToken);
  return decryptData(encryptedToken);
};

// Get user ID from sessionStorage and decrypt
export const getUserId = () => {
  const encryptedId = sessionStorage.getItem("userId");
  const id = decryptData(encryptedId);
  console.log('id:', id);
  return id ? Number(id) : null; // return number
};

export const getRole = () => {
  const encryptedRole = sessionStorage.getItem("role");
  const role = decryptData(encryptedRole);
  return role ? role.toLowerCase() : null; // return number
};

export const getName = () => {
  const encryptedName = sessionStorage.getItem("name");
  const name = decryptData(encryptedName);
  console.log('name:', name);
  return name ? name : null; // return number
};

export const getEmail = () => {
  const encryptedEmail = sessionStorage.getItem("email");
  const email = decryptData(encryptedEmail);
  console.log('email:', email);
  return email ? email : null; // return number
};

export const getGender = () => {
  const encrypteGender = sessionStorage.getItem("gender");
  const gender = decryptData(encrypteGender);
  console.log('gender:', gender);

  return gender ? gender : null; // return number
};